import { useParams } from 'react-router-dom'
import { VaultDetailSection } from '@/components/dashboard/VaultDetailSection'

export function VaultDetailPage() {
  const { address } = useParams()
  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px' }}>
      <VaultDetailSection address={address} />
    </div>
  )
}
